/*
 * @Descripttion:
 * @version:
 * @Author: 周志国
 * @Date: 2025-09-09 09:38:55
 * @LastEditors: 周志国
 * @LastEditTime: 2025-09-11 11:11:05
 * @changeLog:
 * @FilePath: /anov-3d-webgl/packages/anov-3d-ability/src/business/Cylinder/types.ts
 */
import type { MeshBasicMaterialParameters } from '@anov/3d-core'

export type options = {
  radius?: number
  height?: number
  circleSegment?: number
  heightSegment?: number
  openEnded?: boolean
  material?: MeshBasicMaterialParameters
}
